import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: 'input[type="number"]',
  standalone: false
})
export class NumericInputDirective {
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const invalidChars = ['e', 'E', '+', '-'];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }
}